import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { ShareButton } from '@sorare/core/src/components/ShareButton';
import { useMutation } from '@sorare/core/src/hooks/graphql/useMutation';

import type {
  shareCardPackMutation,
  shareCardPackMutationVariables,
} from './__generated__/index.graphql.ts';

const SHARE_CARD_PACK_MUTATION = gql`
  mutation shareCardPackMutation($input: shareCardPackInput!) {
    shareCardPack(input: $input) {
      activity {
        id
      }
      errors {
        message
        code
      }
    }
  }
` as TypedDocumentNode<shareCardPackMutation, shareCardPackMutationVariables>;

type Props = {
  cardSlug: string;
  shared: boolean;
  onShared: () => void;
  highlight?: boolean;
};

export const ShareCardButton = ({
  cardSlug,
  shared,
  onShared,
  highlight = false,
}: Props) => {
  const [shareCardPack] = useMutation(SHARE_CARD_PACK_MUTATION, {
    showErrorsWithSnackNotification: true,
  });

  const share = async () => {
    const { success } = await shareCardPack({
      variables: { input: { cardSlug } },
    });
    if (success) {
      onShared();
    }
  };

  return <ShareButton shared={shared} onShare={share} highlight={highlight} />;
};
